import { render, staticRenderFns } from "./LicensesFragment.vue?vue&type=template&id=27874c92&scoped=true"
import script from "./LicensesFragment.vue?vue&type=script&lang=js"
export * from "./LicensesFragment.vue?vue&type=script&lang=js"
import style0 from "./LicensesFragment.vue?vue&type=style&index=0&id=27874c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27874c92",
  null
  
)

export default component.exports